import {
  type HttpClient,
  HttpError,
  type HttpRequestOptions,
} from '@/infrastructure/http/HttpClient';

export interface FetchHttpClientOptions {
  readonly baseUrl: string;
  readonly timeoutMs?: number;
}

export class FetchHttpClient implements HttpClient {
  private readonly baseUrl: string;
  private readonly timeoutMs: number;

  constructor({ baseUrl, timeoutMs = 10_000 }: FetchHttpClientOptions) {
    this.baseUrl = baseUrl.replace(/\/+$/, '');
    this.timeoutMs = timeoutMs;
  }

  async postJson<TResponse>(
    path: string,
    body: unknown,
    options: HttpRequestOptions = {},
  ): Promise<TResponse> {
    const timeout = AbortSignal.timeout(this.timeoutMs);
    const signal = options.signal ? AbortSignal.any([options.signal, timeout]) : timeout;

    const response = await fetch(`${this.baseUrl}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      signal,
    });

    if (!response.ok) {
      throw new HttpError(response.status, `POST ${path} a échoué (${response.status})`);
    }
    return (await response.json()) as TResponse;
  }
}
